import React, {useState} from "react"
import {breakpoints} from "@next/ux-fabric"
import {formatTextTestIds} from "@next/utils"
import {Ul, Li, AutoCompleteLink} from "./components"
import {SuggestionItem} from "../../../../models/autocomplete"
import TextMatcher from "../../../TextMatcher"
import {handleClick, Focus, handleKeyboardTapping} from "../../../../utils/autocomplete"
import {
    SEARCH_DATA_GA,
    HEADER_AUTOCOMPLETE_LIST_ITEM_DATA_GA,
    AUTOCOMPLETE_DEFAULT_ITEMS,
} from "../../../../config/constants"
import {AutocompleteMaxItemsConfig} from "../../../../models/search"

export type AutocompleteProps = {
    handleSuggestionClick: (suggestion: string) => void
    handleFocus?: (term: string, suggestion: string) => any
    suggestions: SuggestionItem[] | any
    term: string | any
    getConnectedPlpUrl: (suggestion: string, siteUrl: string) => string
    showSelectionHighlight: boolean
    isSimple?: boolean
    autocompleteMaxItems: AutocompleteMaxItemsConfig
    siteUrl: string
}

export const Autocomplete = ({
    handleSuggestionClick,
    handleFocus,
    suggestions,
    term,
    getConnectedPlpUrl,
    autocompleteMaxItems,
    showSelectionHighlight,
    isSimple = false,
    siteUrl,
}: AutocompleteProps) => {
    const [focusIndex, setFocusIndex] = useState(0)
    const getCurrentBreakpoint = () => {
        const windowWidth = window.innerWidth
        const breakpointsValues = Object.entries(breakpoints.values)
        let currentBreakpoint = "xxl"
        breakpointsValues.forEach(([key, value]) => {
            if (windowWidth >= value) {
                currentBreakpoint = key
            }
        })
        return currentBreakpoint
    }

    const maxItems = autocompleteMaxItems[getCurrentBreakpoint()] || AUTOCOMPLETE_DEFAULT_ITEMS

    const filteredSuggestions = suggestions.slice(0, maxItems)
    return (
        <Ul data-testid="searchBar-suggestions">
            {filteredSuggestions.map(({dq: suggestion}, index) => {
                return (
                    <Li
                        key={suggestion}
                        showSelectionHighlight={showSelectionHighlight && !isSimple}
                        isInFocus={focusIndex === index}
                        onMouseEnter={() => setFocusIndex(index)}
                        className="autocomplete-suggestion"
                    >
                        <AutoCompleteLink
                            data-testid={formatTextTestIds(`header-autocomplete-${suggestion}`)}
                            onClick={handleClick(suggestion, siteUrl, handleSuggestionClick)}
                            href={getConnectedPlpUrl(suggestion, siteUrl)}
                            onMouseEnter={Focus(term, suggestion, handleFocus)}
                            onFocus={handleKeyboardTapping(term, suggestion, handleFocus)}
                            data-ga-v1={SEARCH_DATA_GA}
                            data-ga-v2={term}
                            data-ga-v3={HEADER_AUTOCOMPLETE_LIST_ITEM_DATA_GA}
                            data-ga-v4={suggestion}
                        >
                            <TextMatcher text={suggestion} textToMatch={term} />
                        </AutoCompleteLink>
                    </Li>
                )
            })}
        </Ul>
    )
}

export default Autocomplete
